import { render, staticRenderFns } from "./Vendas2Form.vue?vue&type=template&id=9bcab410&scoped=true&"
import script from "./Vendas2Form.vue?vue&type=script&lang=js&"
export * from "./Vendas2Form.vue?vue&type=script&lang=js&"
import style0 from "./Vendas2Form.vue?vue&type=style&index=0&id=9bcab410&scoped=true&lang=css&"
import style1 from "./Vendas2Form.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcab410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VDivider,VIcon,VProgressCircular,VRow,VTooltip})
